import {
  IProvider,
  TravelService,
  CurrencyService,
  ServiceService,
  InfoService,
  CustomerService,
  PlatformService,
  RequestService,
  PaymentService,
  PromoCodeService
} from './index'
import axios, {AxiosInstance, AxiosRequestConfig} from 'axios'

const DEFAULT_PAGE_SIZE = 100


const getAxiosConfig = (base: string): AxiosRequestConfig => ({
  baseURL: base,
  headers: {
    'Content-Type': 'application/json'
  },
  params: {
    page_size: DEFAULT_PAGE_SIZE
  },
  paramsSerializer(params) {
    const searchParams = new URLSearchParams();
    for (const key of Object.keys(params)) {
      const param = params[key];
      if (Array.isArray(param)) {
        if (param.length) {
          searchParams.append(key, param.join(','));
        }
      } else if (param) {
        searchParams.append(key, param);
      }
    }
    return searchParams.toString();
  }
})
const getAxiosInstance = (base: string, root: string): AxiosInstance => axios.create(getAxiosConfig(base + root))

export const provider = (base: string): IProvider => {
  return {
    travel: new TravelService(getAxiosInstance(base, '/travel')),
    currency: new CurrencyService(getAxiosInstance(base, '/currency')),
    service: new ServiceService(getAxiosInstance(base, '/service')),
    info: new InfoService(getAxiosInstance(base, '/info')),
    customer: new CustomerService(getAxiosInstance(base, '/customer')),
    platform: new PlatformService(getAxiosInstance(base, '/platform')),
    request: new RequestService(getAxiosInstance(base, '/request')),
    payment: new PaymentService(getAxiosInstance(base, '/stripe')),
    promo: new PromoCodeService(getAxiosInstance(base, '/promo_code'))
  }
}
